import { FC, memo } from 'react';

import { IconBase, IconBaseProps } from './IconBase';

export const IconTechnology: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} viewBox="0 0 56 56">
      <circle
        cx="8.16658"
        cy="8.16683"
        r="5.83333"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <ellipse
        cx="8.16658"
        cy="27.9998"
        rx="5.83333"
        ry="5.83333"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <ellipse
        cx="8.16658"
        cy="47.8333"
        rx="5.83333"
        ry="5.83333"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <ellipse
        cx="28.0001"
        cy="8.16683"
        rx="5.83333"
        ry="5.83333"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle
        cx="28.0001"
        cy="27.9998"
        r="5.83333"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <ellipse
        cx="28.0001"
        cy="47.8333"
        rx="5.83333"
        ry="5.83333"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <ellipse
        cx="47.8333"
        cy="8.16683"
        rx="5.83333"
        ry="5.83333"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <ellipse
        cx="47.8333"
        cy="27.9998"
        rx="5.83333"
        ry="5.83333"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle
        cx="47.8333"
        cy="47.8333"
        r="5.83333"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M8.16675 14V22.1667"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M33.8333 8.1665H41.9999"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M28 33.8335V42.0002"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M33.25 44.3333L44.3333 33.25"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.8333 23.9168L23.9166 12.8335"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </IconBase>
  );
});
